import React from "react";
import PropTypes from "prop-types";

const Error = props => {
  const { text } = props;
  return <div className="form-item__error">{text}</div>;
};

Error.propTypes = {
  text: PropTypes.string.isRequired
};

export default Error;
